<div class="flex w-full flex-col rounded-lg bg-aux-gray-light">
  <div class="flex flex-row items-center justify-between px-4 pb-6 pt-4">
    <div class="flex items-center space-x-2">
      <aux-icon name="ChartAreaLine" />
      <span class="text-aux-gray-dark-100">Comparison</span>
    </div>
    <span class="text-sm text-aux-gray-darkest">To Date</span>
  </div>
  <div class="flex flex-row items-center space-x-2 px-4 pb-6 text-aux-gray-darkest">
    <aux-icon name="Sparkles" class="flex-shrink-0" />
    <span class="text-sm text-aux-gray-darkest">
      Compare actual enrollment against forecasted metrics to date, to gain insights for a better
      analysis
    </span>
  </div>

  @if (comparisonCards$ | async; as comparisonCards) {
    <div class="flex w-full flex-col items-center space-y-6 px-4 pb-4">
      @for (card of comparisonCards; track card) {
        <div class="w-full">
          <aux-ag-patient-driver-comparison-card [card]="card" />
        </div>
      }
    </div>
  }
</div>
